<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">

        <v-col cols="12" class="pa-0 px-3 pt-4">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Lotti</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                
                <!-- Criterio di preselezione lotto -->
                <v-subheader class="pl-4">Preselezione Lotti</v-subheader>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                                color="primary" 
                                hide-details
                                v-model="settings['lot_preselection_enabled']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Preselezione automatica lotto</v-list-item-title>
                            <v-list-item-subtitle>
                                Preseleziona automaticamente il lotto con data di scadenza più imminente
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <!-- Blocco giacenza lotto -->
                <v-subheader class="pl-4">Controllo Giacenza Lotti</v-subheader>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                                color="primary"
                                hide-details
                                v-model="settings['lot_stock_check_blocking']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Blocca il salvataggio se la quantità supera la giacenza del lotto</v-list-item-title>
                            <v-list-item-subtitle>
                                Se disattivo, l'eccedenza viene solo segnalata (avviso non bloccante)
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <!-- Codici lotto non univoci -->
                <v-subheader class="pl-4">Gestione Codici Lotto</v-subheader>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                                color="primary" 
                                hide-details
                                v-model="settings['allow_duplicate_lot_codes']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Consenti codici lotto non univoci</v-list-item-title>
                            <v-list-item-subtitle>
                                Permette di inserire codici lotto duplicati per prodotti diversi
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <!-- Notifiche scadenza lotti -->
                <v-subheader class="pl-4">Notifiche Scadenza Lotti</v-subheader>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                                color="primary" 
                                hide-details
                                v-model="settings['notify_expiring_lot']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Lotti</v-list-item-title>
                            <v-list-item-subtitle>
                                Ricevi una notifica quando un lotto sta per scadere
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_expiring_lot']">
                        <v-list-item>
                            <v-list-item-action></v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field 
                                    label="Numero giorni prima"
                                    v-model="settings['notify_expiring_lot_day_before']"
                                    type="number"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('daybefore_lot')"
                                    v-validate="'required'"
                                    data-vv-name="daybefore_lot"
                                    data-vv-as="Numero giorni prima"
                                ></v-text-field>   
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-action></v-list-item-action>
                            <v-list-item-content>
                                <v-autocomplete
                                    v-model="settings['notify_expiring_lot_users']"
                                    :items="usersList"
                                    item-text="value"
                                    item-value="id"
                                    chips
                                    label="Utenti da notificare"
                                    multiple
                                    outlined
                                    clearable
                                    dense
                                    :error-messages="errors.collect('lot_users')"
                                    v-validate="'required'"
                                    data-vv-name="lot_users"
                                    data-vv-as="Utenti da notificare"
                                    :menu-props="{maxHeight:'200', nudgeBottom: 3}">
                                    <template v-slot:selection="{ item, index }">
                                        <v-chip small>
                                            <v-avatar v-if="item.avatar" left>
                                                <v-img :src="item.avatar"></v-img>
                                            </v-avatar>
                                            <v-avatar v-else color="primary" left size="24">
                                                <span class="white--text caption">{{ item.value.charAt(0) }}</span>
                                            </v-avatar>
                                            <span>{{ item.value }}</span>
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar v-if="item.avatar">
                                            <v-img :src="item.avatar"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-avatar v-else color="primary">
                                            <span class="white--text">{{ item.value.charAt(0) }}</span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.value }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>
                
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>                
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin.js'

    export default {
        name: 'lots-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'products',
                settings: {
                    'lot_preselection_enabled': false,
                    'lot_stock_check_blocking': false,
                    'allow_duplicate_lot_codes': false,
                    'notify_expiring_lot': false,
                    'notify_expiring_lot_day_before': 7,
                    'notify_expiring_lot_users': [],
                },
                loading: false,
            }
        },

        computed: {
            usersList() {
                return this.$store.getters.usersSeq
            }
        },

        methods: {

        },
        watch: {
            'settings.notify_expiring_lot': {
                handler() {
                    if(!this.settings['notify_expiring_lot']) {
                        this.$set(this.settings, 'notify_expiring_lot_day_before', null)
                        this.$set(this.settings, 'notify_expiring_lot_users', [])
                    }
                },
                deep: true,
            }
        }
    }
</script>

<style scoped>

</style>